<mat-card class="google-maps view modern-layout">
  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!loading" class="content-container">
    <div class="profile-wrapper">
      <div class="info-container">
        <mat-tab-group>
          <mat-tab label="Informações">
            <div class="photo-container">
              <img
                class="profile-photo"
                [src]="practitionerData?.photo && practitionerData.photo.trim() !== '' ? practitionerData.photo : defaultPractitionerPhoto"
                alt="Foto do Especialista"
              />
            </div>

            <div style="margin-top: 12px" class="info-section">
              <p class="label blue-text">Nome:</p>
              <p class="value">{{ practitionerData.name }}</p>
            </div>

            <div *ngIf="practitionerData.qualifications">
              <div *ngFor="let qualification of practitionerData.qualifications" class="info-section">
                <p class="label blue-text">Qualificação:</p>
                <p class="value">{{ qualification.name }}</p>
                <p class="label blue-text">Instituição de Ensino:</p>
                <p class="value">{{ qualification.instituition }}</p>
                <p class="label blue-text">Grau de Instrução:</p>
                <p class="value">{{ qualification.level }}</p>
              </div>
            </div>

            <div *ngIf="practitionerData.certificates">
              <div *ngFor="let certificate of practitionerData.certificates" class="info-section">
                <p class="label blue-text">Certificado:</p>
                <p class="value">{{ certificate.name }}</p>
                <p class="label blue-text">Instituição de Ensino:</p>
                <p class="value">{{ certificate.instituition }}</p>
              </div>
            </div>

            <div *ngIf="practitionerData.communication">
              <div *ngFor="let communication of practitionerData.communication" class="info-section">
                <p class="label blue-text">Idiomas:</p>
                <p class="value">{{ communication.language }}</p>
                <p class="label blue-text">Proeficiência:</p>
                <p class="value">{{ communication.proficiency }}</p>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Especialidades">
            <div style="margin-top: 12px" *ngFor="let specialty of practitionerRoleData.specialty" class="info-section">
              <p class="label blue-text">Especialidade:</p>
              <p class="value">{{ specialty.value }}</p>
              <p class="label blue-text">CRM/UF:</p>
              <p class="value">{{ specialty.crm }}/{{ specialty.uf }}</p>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</mat-card>
